import { motion } from "framer-motion";
import { useState } from "react";
import { FaRegBell } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) return;

    try {
      const response = await fetch("https://formspree.io/f/xgvyapkj", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setShowModal(true);
        setEmail("");
      } else {
        console.error("Formspree error:", await response.json());
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const closeModal = () => setShowModal(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-grid">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <img src="/FL.png" alt="Logo" className="logo" />
            <p className="footer-text">
              Shaping Africa’s Future — One Business at a Time{" "}
            </p>
            <div className="footer-icons">
              <i className="fab fa-twitter" />
              <i className="fab fa-linkedin-in" />
              <i className="fab fa-instagram" />
              <i className="fab fa-facebook" />
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-list">
              <Link to="/about">
                <li>About Us</li>
              </Link>
              <Link to="/">
                <li>Our Ventures</li>
              </Link>
              <Link to="/blog">
                <li>Blog</li>
              </Link>
              <Link to="/team">
                <li>Team</li>
              </Link>
              <Link to="/contact">
                <li>Contact Us</li>
              </Link>
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h3 className="footer-heading">Our Ventures</h3>
            <ul className="footer-list">
              <Link to="/partners">
                <li>Nexa Partners</li>
              </Link>
              <Link to="/accelerator">
                <li>Nexa Accelerate</li>
              </Link>
              <Link to="/elevate">
                <li>Nexa Elevate</li>
              </Link>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h3 className="footer-heading">Our Address</h3>
            <ul className="footer-list">
              <li>NexaGrowth Africa</li>
              <li>16 Coquette Street</li>
              <li>Madina New Road</li>
              <li>Accra, Ghana</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <form onSubmit={handleSubscribe} className="footer-form">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="footer-input"
              />
              <button type="submit" className="footer-button">
                <FaRegBell /> Subscribe
              </button>
            </form>
          </motion.div>
        </div>

        <div className="footer-bottom">
          <p>© 2024 NexaGrowth Africa. All rights reserved.</p>
        </div>
      </footer>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Thank You!</h2>
            <p>You’ve successfully subscribed with your email.</p>
            <button onClick={closeModal} className="modal-close-button">
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
